import React from 'react'
import { connect } from 'react-redux'

import OptionList from '../option-list'
import { sortOptions } from '../../../utils/option-sort'

const mapStateToProps = (state) => {
    return {
        options: sortOptions(state.adminVibes)
    }
}

const Vibes = ({ options }) => {
    return (
        <OptionList
            endpoint="admin/vibes"
            options={options}
            singular="Vibe" />
    )
}

export default connect(mapStateToProps)(Vibes)
